import type { Package } from '../types/subscription';

/** The days of forecast every plan gets, whatever it is set to (vortexnav-client weather migration, decision 5). */
const DEFAULT_WEATHER_DAYS = 2;

/**
 * The short feature list on a plan's card in MyPolaris's Change plan dialog.
 * Lists only what a plan really switches on: the retired weather switches and
 * the unused tide switches are kept on the plan but never shown (Tony, 31 Oct 2026).
 */
export function planKeyFeatures(pkg: Package): string[] {
  const days = pkg.weather_days ?? DEFAULT_WEATHER_DAYS;
  return [
    days > DEFAULT_WEATHER_DAYS && `${days}-day forecast`,
    pkg.weather_colour && 'Weather colour shading',
    pkg.ais_integration && 'AIS Integration',
    pkg.bathymetry && 'Bathymetry',
    pkg.instrument_panel && 'Instrument Panel',
    pkg.vortex_anchor && 'Vortex Anchor',
    pkg.truehelm && 'TrueHelm',
  ].filter(Boolean) as string[];
}
